export default __webpack_public_path__ + "static/media/export.8d255db6.svg";